import { render, staticRenderFns } from "./combat_knockout_old.vue?vue&type=template&id=dc76dd2c&scoped=true"
import script from "./combat_knockout_old.vue?vue&type=script&lang=js"
export * from "./combat_knockout_old.vue?vue&type=script&lang=js"
import style0 from "./combat_knockout_old.vue?vue&type=style&index=0&id=dc76dd2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc76dd2c",
  null
  
)

export default component.exports